module.exports = __webpack_public_path__ + "static/media/zyla.5a481710.png";